module.exports = __webpack_public_path__ + "images/97b693ec616481fb0f51811423a3ada0.png";